import React from 'react';
import styled from 'styled-components';

import Link from '@util/link';

const MainLink = styled(Link)`
	border-radius: 8px;
	background: ${({ theme, secondary, backgroundColor }) =>
		backgroundColor
			? backgroundColor
			: secondary
				? 'transparent'
				: theme.colors.primary.main};
	border: 2px solid
		${({ theme, secondary, backgroundColor }) =>
			backgroundColor
				? backgroundColor
				: secondary
					? theme.colors.black.main
					: theme.colors.primary.main};

	color: ${({ theme, secondary }) =>
		secondary ? theme.colors.black.main : theme.colors.white.main};
	display: flex;
	padding: 1.8rem 3rem;
	justify-content: center;
	align-items: flex-start;
	width: fit-content;

	font-family: ${props => props.theme.fonts.subheadingMedium};
	font-size: 1.6rem;
	line-height: 100%; /* 16px */
	letter-spacing: 0.16px;

	:hover {
		background: ${({ theme, secondary, hoverColor }) =>
			hoverColor
				? hoverColor
				: secondary
					? theme.colors.black.main
					: theme.colors.primary.dark};
		color: ${({ theme }) => theme.colors.white.main};
		border: 2px solid
			${({ theme, secondary, hoverColor }) =>
				hoverColor
					? hoverColor
					: secondary
						? theme.colors.black.main
						: theme.colors.primary.dark};
	}
`;

const MainButton = ({
	anchorLink,
	linkUrl,
	children,
	secondary,
	className,
	backgroundColor,
	hoverColor,
	...props
}) => {
	return (
		<MainLink
			className={className}
			to={linkUrl}
			anchorLink={anchorLink}
			secondary={secondary}
			backgroundColor={backgroundColor}
			hoverColor={hoverColor}
			{...props}
		>
			{children}
		</MainLink>
	);
};

export default MainButton;
